import React from "react";
import useSeo from "@/hooks/useSeo";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeader from "@/components/PageHeader";
import AiScan from "@/components/AiScan";

const AiScanPage = () => {
  useSeo({
    title: "AI Growth Scan | Gratis persoonlijk groeiadvies in 2 minuten",
    description:
      "Doe de gratis AI Growth Scan van UPPIT. 6 vragen, een Growth Score op basis van AI, geschatte gemiste omzet en een persoonlijk 90-dagen actieplan.",
    path: "/ai-scan",
    ogSlug: "page/ai-scan",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "UPPIT AI Strategie Scan",
      url: "https://uppit.nl/ai-scan",
      applicationCategory: "BusinessApplication",
      offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
    },
  });

  return (
    <main data-testid="ai-scan-page" className="bg-ivory">
      <section className="pt-32 max-w-[1400px] mx-auto px-6 lg:px-12">
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "AI Scan", href: "/ai-scan" },
          ]}
        />
        <PageHeader
          kicker="AI Growth Scan · Gratis"
          italic="Zes vragen."
          bold="Eén eerlijk plan."
          lede="Beantwoord 6 slimme vragen — onze AI-strategist berekent waar je online staat, hoeveel omzet je gemiddeld per maand misloopt en welke 3 prioriteiten je nu moet aanpakken. Gratis, binnen 2 minuten, geen verplichtingen."
        />
      </section>
      <AiScan />
    </main>
  );
};

export default AiScanPage;
